import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pdt-30" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center pdb-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Autoresponders", -1)
const _hoisted_4 = { class: "bordered-card bordered-card_secondary" }
const _hoisted_5 = { class: "small striped toggle no-underline" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "large" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "pdl-10 pdr-10 d-flex justify-content-between w-100" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Title "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, " Form "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Action "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, " Result "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Actions ")
      ])
    ])
  ])
], -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { colspan: "6" }
const _hoisted_9 = { class: "d-flex flex-column w-100" }
const _hoisted_10 = { class: "d-flex justify-content-between w-100" }
const _hoisted_11 = { class: "cell col-md-1" }
const _hoisted_12 = { class: "cell col-md-1" }
const _hoisted_13 = { class: "cell col-md-2" }
const _hoisted_14 = { class: "cell col-md-2" }
const _hoisted_15 = { class: "cell col-md-1" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("tr", { class: "text-center py-5" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, " No Existing Autoresponders")
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-primary plan-modal",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openModal('add-autoresponder', 'Add Autoresponder', 'plan-upload  plan-card-info')))
      }, " Create new Autoresponder ")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _hoisted_6,
        ($setup.loading)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
          : ($setup.autoresponders.length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.autoresponders, (autoresponder) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: autoresponder.UIAutoresponderID,
                    class: "large"
                  }, [
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(autoresponder.Description), 1),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(autoresponder.Form), 1),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(autoresponder.Action), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(autoresponder.Result), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("i", {
                              class: "plan-modal iatse-icon-edit fs-6 fw-semibold",
                              onClick: ($event: any) => ($setup.handleEdit(autoresponder.UIAutoresponderID))
                            }, null, 8, _hoisted_16)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_17, _hoisted_19))
      ])
    ])
  ]))
}